import { useApiQualityReportV1SiteMaterialExistsRetrieve } from 'api';
import { Button, Tooltip } from 'ui';

export const getTooltipTitle = (isEnoughEvidence: boolean, isSiteMaterialIdPresent: boolean) => {
  if (!isSiteMaterialIdPresent) {
    return 'No material selected';
  }
  if (!isEnoughEvidence) {
    return 'Not enough evidence for selected material';
  }
  return '';
};

export const QualityReportLink = ({
  siteMaterialPublicId,
  disabled,
  fullWidth = true,
  size,
  tradeCompanyId,
}: {
  siteMaterialPublicId?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  tradeCompanyId?: number;
}) => {
  const isSiteMaterialIdPresent = Boolean(siteMaterialPublicId);

  const { isError, isSuccess, isLoading } = useApiQualityReportV1SiteMaterialExistsRetrieve(
    siteMaterialPublicId || '',
    {
      query: { enabled: isSiteMaterialIdPresent, retry: false },
    }
  );

  const URL = tradeCompanyId
    ? `/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/${siteMaterialPublicId}/report/`
    : `/report/${siteMaterialPublicId}/`;

  return (
    <Tooltip title={getTooltipTitle(isSuccess, isSiteMaterialIdPresent)}>
      <Button
        fullWidth={fullWidth}
        data-testid="quality-report-link"
        variant="secondary"
        size={size}
        component="a"
        href={URL}
        target="_blank"
        loading={isLoading}
        disabled={disabled || isError}
      >
        Quality Report
      </Button>
    </Tooltip>
  );
};
